import React, { useMemo } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import InspectionAssistantInsightsDashboard from './components/InspectionAssistantInsightsDashboard';
import './styles.scss';
function InspectionAssistantInsights() {
    const queryClient = useMemo(() => new QueryClient(), []);
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(InspectionAssistantInsightsDashboard, null)));
}
export default InspectionAssistantInsights;
